import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_TRAVEL_INTERRUPTION_STATE,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
     // Travel Cancellation
    tripCancellation: 'false',
    reasonForTripCancellation: [],
    companyNameTravelCancellation: '',
    addressTravelCancellation: '',
    cityTravelCancellation: '',
    stateTravelCancellation: '',
    zipCodeTravelCancellation: '',
    contactTravelCancellation: '',
    phoneNumberTravelCancellation: '',
    includedInPackageTravelCancellation: '',
    dateTravelCancellation: '',
    reasonForTravelCancellation: '',
    nameOfPersonHavingSicknessTravelCancellation: '',
    dateOfBirthTravelCancellation: '',
    relationshipToClaimantTravelCancellation: '',
    dateSicknessOrInjuryBeganTravelCancellation: '',
    dateEndedTravelCancellation: '',
    natureOfSicknessOrInjuryTravelCancellation: '',
    lossInformationItemsTravelCancellation: [],
    fromDateTravelCancellation: '',
    toDateTravelCancellation: '',
    dateOfInitialPaymentDepositTravelCancellation: '',
    insuredsTravelCancellation: [],
    enableTimeTravelCancellation: null,
    // Trip Cancellation for Any Reason
    tripCancellationForAnyReason: 'false',
    companyNameTripCancellationForAnyReason: '',
    addressTripCancellationForAnyReason: '',
    cityTripCancellationForAnyReason: '',
    stateTripCancellationForAnyReason: '',
    zipCodeTripCancellationForAnyReason: '',
    contactTripCancellationForAnyReason: '',
    phoneNumberTripCancellationForAnyReason: '',
    includedInPackageTripCancellationForAnyReason: '',
    dateTripCancellationForAnyReason: '',
    reasonForTripCancellationForAnyReason: '',
    lossInformationItemsTripCancellationForAnyReason: [],
    toDateTripCancellationForAnyReason: '',
    dateOfInitialPaymentDepositTripCancellationForAnyReason: '',
    insuredsTripCancellationForAnyReason: [],
    // Travel Interruption
    travelInterruption: 'false',
    reasonsForTripInterruption: [],
    companyNameTravelInterruption: '',
    enableTimeInterruption: null,
    addressTravelInterruption: '',
    cityTravelInterruption: '',
    stateTravelInterruption: '',
    zipCodeTravelInterruption: '',
    contactTravelInterruption: '',
    phoneNumberTravelInterruption: '',
    includedInPackage: '',
    dateTripInterrupted: '',
    reasonForInterruption: '',
    nameOfPersonHavingSickness: '',
    dateOfBirth: '',
    relationshipToClaimant: '',
    dateSicknessOrInjuryBegan: '',
    dateEnded: '',
    natureOfSicknessOrInjury: '',
    periodOfHospitalization: '',
    lossInformationItems: [],
    fromDate: '',
    toDate: '',
    dateOfInitialPaymentDepositForInterruption: '',
    insuredsForInterruption: [],
  },
  errors: [],
});

const initialTravelInterruptionState = {
  form: {
    travelInterruption: 'false',
    reasonsForTripInterruption: [],
    companyNameTravelInterruption: '',
    addressTravelInterruption: '',
    cityTravelInterruption: '',
    stateTravelInterruption: '',
    zipCodeTravelInterruption: '',
    contactTravelInterruption: '',
    phoneNumberTravelInterruption: '',
    includedInPackage: '',
    dateTripInterrupted: '',
    nameOfPersonHavingSickness: '',
    dateOfBirth: '',
    relationshipToClaimant: '',
    dateSicknessOrInjuryBegan: '',
    dateEnded: '',
    natureOfSicknessOrInjury: '',
    periodOfHospitalization: '',
    lossInformationItems: [],
    fromDate: '',
    toDate: '',
  },
};

function tripCancellationCFStepReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_TRAVEL_INTERRUPTION_STATE:
      return state
           .setIn(['form', 'lossInformationItems'], [])
           .mergeDeep(initialTravelInterruptionState);
    default:
      return state;
  }
}

export default tripCancellationCFStepReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.CFTripCan.TripCancellationStep/reducer.js